import { render, staticRenderFns } from "./embed.vue?vue&type=template&id=058b7650&"
import script from "./embed.vue?vue&type=script&lang=js&"
export * from "./embed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nasa8x/nasa/projects/nodejs/v-video-embed/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('058b7650')) {
      api.createRecord('058b7650', component.options)
    } else {
      api.reload('058b7650', component.options)
    }
    module.hot.accept("./embed.vue?vue&type=template&id=058b7650&", function () {
      api.rerender('058b7650', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/embed.vue"
export default component.exports